import { ModalAction, ModalInstance, ModalState } from './types';

/**
 * Modal reducer for managing modal instances state
 */
export function modalReducer(state: ModalState, action: ModalAction): ModalState {
  switch (action.type) {
    case 'ADD_MODAL':
      return {
        ...state,
        instances: [...state.instances, action.payload],
      };

    case 'REMOVE_MODAL':
      return {
        ...state,
        instances: state.instances.filter((instance) => instance.id !== action.payload),
      };

    case 'SET_VISIBLE':
      return {
        ...state,
        instances: state.instances.map((instance) =>
          instance.id === action.payload.id ? { ...instance, visible: action.payload.visible } : instance
        ),
      };

    case 'SET_LOADING':
      return {
        ...state,
        instances: state.instances.map((instance) =>
          instance.id === action.payload.id
            ? {
                ...instance,
                state: {
                  ...instance.state,
                  [`${action.payload.type}Loading`]: action.payload.loading,
                },
              }
            : instance
        ),
      };

    case 'CLEAR_ALL':
      return {
        ...state,
        instances: [],
      };

    default:
      return state;
  }
}

/**
 * Initial state for modal reducer
 */
export const initialModalState: ModalState = {
  instances: [],
};

/**
 * Helper function to generate unique modal IDs
 */
export function generateModalId(): string {
  return `modal_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Helper function to find modal instance by ID
 */
export function findModalInstance<T = unknown>(instances: ModalInstance[], id: string): ModalInstance<T> | undefined {
  return instances.find((instance) => instance.id === id) as ModalInstance<T> | undefined;
}
